import { render, staticRenderFns } from "./TelehealthEHR.vue?vue&type=template&id=7a0973ae&"
import script from "./TelehealthEHR.vue?vue&type=script&lang=js&"
export * from "./TelehealthEHR.vue?vue&type=script&lang=js&"
import style0 from "./TelehealthEHR.vue?vue&type=style&index=0&id=7a0973ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports